const adyenEncrypt = require('adyen-cse-web');

export class Order {
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.data = options.data;
        this.url = options.url;
    }

    createOrder() {
        this.state = this.store.getState();
        const formFields = this.state.formFields.reduce((obj, field) => {
            obj[field.id] = field; // eslint-disable-line no-param-reassign
            return obj;
        }, {});
        const {
            product
        } = this.state;


        const paymentType = (formFields.paymentType && (formFields.paymentType.value === 'radio-creditcard')) ? 1 : 2;
        const key = this.state.settings.adyen_key;
        const options = {}; // See adyen.encrypt.nodom.html for details
        const cseInstance = adyenEncrypt.createEncryption(key, options);
        let orderData = null;
        let cardData = {};

        if (paymentType === 1) {
            cardData = {
                number : formFields.ccnumber.value,
                cvc : formFields.cvvnumber.value,
                holderName : formFields.ccAccountName.value,
                expiryMonth : formFields.expirationDate.value.split('/')[0],
                expiryYear : `20${formFields.expirationDate.value.split('/')[1]}`,
                generationtime : new Date().toISOString(),
            };
        }

        orderData = {
            'UserName': 'value',
            'AddressLine1': formFields.street.value,
            'AddressLine2': formFields.address.value,
            'Company': formFields.companyName.value,
            'City': formFields.city.value,
            'Email': formFields.email.value,
            'FirstName': formFields.firstName.value,
            'Insertion': formFields.insertion.value,
            'LastName': formFields.lastName.value,
            'PackageID': product.packageId,
            'PackageTerm': product.contractTermId,
            'Password': formFields.password.value,
            'Phone': formFields.telephone.value,
            'Postcode': formFields.postalCode.value,
            'ProductName': product.packageCode,
            'Title': 'tav',
            'MigrationType': formFields.migrationType.value,
            'VatNumber': formFields.vatNumber.value,
            'Source': (Object.prototype.hasOwnProperty.call(formFields.source, 'value')) ? formFields.source.value : '',
            'PaymentDetail': {
                'PaymentMethod': paymentType,
                'BankAccountCountry': paymentType === 2 ? formFields.country.value : '',
                'BankAccountName': paymentType === 2 ? formFields.sepaAccountName.value : '',
                'BankAccountNumber': paymentType === 2 ? formFields.sepaIbanNumber.value : '',
                'CreditCardEncryptedCardData': paymentType === 1 ? cseInstance.encrypt(cardData) : '',
            },
            'AddOn': this.getActiveAddons(),
            'Url': window.location.href
        };

        if (this.state.settings.has_migration_arrangement) {
            orderData.CustomerType = formFields.customerType.value === 'radio-new-customer' ? 'New' : 'Existing';
        }

        return orderData;
    }

    getActiveAddons() {
        const users = this.state.users.filter(user => user.numberOfUsers > 1 && user.numberOfUsers > user.numberOfFreeUsers).map(user => (
            {
                'Id': user.id,
                'Quantity': (user.numberOfUsers - user.numberOfFreeUsers),
                'Type': 1,
            }
        ));

        // We can only send content providers if we have a matching client, and it needs to be the same amount
        const contentProviders = this.state.users.filter(u => u.numberOfUsers > 1 && u.numberOfUsers > u.numberOfFreeUsers && u.chosenProvider && u.chosenProvider.length > 0).map(u => (
            {
                'Id': u.chosenProvider[0].id,
                'Quantity': u.numberOfUsers,
                'Type': 6,
            }
        ));

        const extras = this.state.extras.filter(extra => extra.active).map(extra => (
            {
                'Id': extra.id,
                'Quantity': 1,
                'Type': 3,
            }
        ));
        const modules = this.state.modules.filter(module => module.active && !Number(module.numberOfItems)).map(module => (
            {
                'Id': module.id,
                'Quantity': 1,
                'Type': 2,
            }
        ));

        const bundleModules = this.state.modules.filter(module => module.active && Number(module.numberOfItems)).map(module => (
            {
                'Id': module.id,
                'Quantity': 1,
                'Type': 2,
                'BundleQuantity': module.numberOfItems,
            }
        ));

        return [...users, ...modules, ...bundleModules, ...extras, ...contentProviders ];
    }

    async submit(token = false) { // eslint-disable-line class-methods-use-this
        const order = this.createOrder();
        order.token = token;

        try {
            const res = await fetch(this.url, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(order), // data can be `string` or {Object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const response = await res.json();

            return response;
        }
        catch (error) {
            return console.error('Error:', error);
        }
    }

    async submitName(name) { // eslint-disable-line class-methods-use-this
        const order = this.createOrder();
        order.UserName = name;

        try {
            const res = await fetch(this.url, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(order), // data can be `string` or {Object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const response = await res.json();

            return response;
        }
        catch (error) {
            return console.error('Error:', error);
        }
    }
}

export default Order;
